module.exports = __webpack_public_path__ + "media/Destiny.b549b635.mp3";